<template>
  <div class="row">
    <div class="col-12 col-lg-8 c g">

        <button @click="seeAll()" class="btn btn-sm btn-primary">
            <i class="fa fa-eye"></i>
            تمت رؤية الكل
        </button>
    </div>
    <div class="col-12 col-lg-8 c">
        <div class="card card-body border" v-for="post in posts" :key="post._id">
            <h4>
                {{ post.title }}
            </h4>
            <div v-html="post.content.replace(`oembed url=`, `iframe style='width: 100%; height: 400px' src=`).replace(`watch?v=`, 'embed/')"></div>
            <div>
                <button @click="see(post._id)" v-if="!post.isSeen" class="btn btn-sm btn-primary">
                <i class="fa fa-eye"></i>
                تعيين كتمت رؤيته
            </button><br>
            <small>{{post.date}}</small>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            posts: [],
            user: JSON.parse(localStorage.getItem('user')),
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/general/posts', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.posts = r.response
                }
            }).fail(function(){
                alert("حدث خطأ")
                g.loading = false
            })
        },
        seeAll(){
            var g = this;
            $.post(api + '/user/general/show-posts', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.gett()
                }
            }).fail(function(){
                alert("حدث خطأ")
                g.loading = false
            })
        },
        see(id){
            var g = this;
            $.post(api + '/user/general/show-posts-single', {
                jwt: this.user.jwt,
                id: id
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.gett()
                }
            }).fail(function(){
                alert("حدث خطأ")
                g.loading = false
            })
        }
    }
}
</script>

<style>

</style>